import axios from '@axios'
import Vue from 'vue'

const state = () => ({
  // Datos
  warehouse: {
    meta: {
      pagination: {
        page: 1,
        per_page: 500, // el endpoint regresa lista plana; usamos "per_page" para UI
        total_objects: 0,
      },
    },
    data: [],
  },

  totals: {
    with_freight: null,
    without_freight: null,
  },

  // Filtros
  filters: {
    folio: '', // acepta "F123" o "123"
    default_tax_rate: null, // ej. 0.16
    month: null,
  },

  // Loading UI
  loading: false,
})

const getters = {
  warehouseRows(state) {
    return state.warehouse.data
  },
  warehousePagination(state) {
    return state.warehouse.meta.pagination
  },
  warehouseLoading(state) {
    return state.loading
  },
  warehouseFilters(state) {
    return state.filters
  },

  warehouseTotals(state) {
    return state.totals
  },
}

const mutations = {
  SET_WAREHOUSE_ROWS(state, items) {
    const { page, per_page: perPage } = state.warehouse.meta.pagination
    const arr = Array.isArray(items) ? items : []
    state.warehouse = {
      data: arr,
      meta: {
        pagination: {
          page,
          per_page: perPage,
          total_objects: arr.length,
        },
      },
    }
  },

  SET_WAREHOUSE_TOTALS(state, totals) {
    state.totals = totals || { with_freight: null, without_freight: null }
  },

  SET_WAREHOUSE_LOADING(state, val) {
    state.loading = !!val
  },

  SET_WAREHOUSE_FILTER(state, { field, value }) {
    if (!Object.prototype.hasOwnProperty.call(state.filters, field)) return
    Vue.set(state.filters, field, value)
  },

  CLEAR_WAREHOUSE(state) {
    state.warehouse = {
      meta: { pagination: { page: 1, per_page: 500, total_objects: 0 } },
      data: [],
    }
    state.totals = { with_freight: null, without_freight: null }
  },

  CLEAR_WAREHOUSE_FILTERS(state) {
    state.filters = { folio: '', default_tax_rate: null, month: state.filters.month }
  },

  CHANGE_WAREHOUSE_PAGINATION(state, { field, value }) {
    state.warehouse.meta.pagination[field] = value
  },
}

const actions = {
  async fetchWarehouse({ commit, state }, paramsOverride = {}) {
    commit('SET_WAREHOUSE_LOADING', true)
    try {
      const params = {}
      const { folio, default_tax_rate: rate, month } = state.filters

      if (folio) params.folio = folio
      if (rate !== null && rate !== undefined && rate !== '') {
        params.default_tax_rate = rate
      }

      // Siempre incluir el mes si existe
      if (month) params.month = month

      Object.assign(params, paramsOverride)

      const { data } = await axios.get('/v1/warehouse', { params })

      const rows = Array.isArray(data) ? data : (data?.rows ?? [])
      commit('SET_WAREHOUSE_ROWS', rows)

      const totals = Array.isArray(data) ? null : (data?.totals ?? null)
      commit('SET_WAREHOUSE_TOTALS', totals)

      return data
    } finally {
      commit('SET_WAREHOUSE_LOADING', false)
    }
  },

  setWarehouseFilter({ commit }, { field, value }) {
    commit('SET_WAREHOUSE_FILTER', { field, value })
  },

  applyWarehouseFilters({ dispatch }) {
    return dispatch('fetchWarehouse')
  },

  clearWarehouseFilters({ commit, dispatch }) {
    commit('CLEAR_WAREHOUSE_FILTERS')
    return dispatch('fetchWarehouse')
  },

  // evitamos no-shadow usando context en vez de { getters }
  changeWarehousePagination(context, { field, value }) {
    context.commit('CHANGE_WAREHOUSE_PAGINATION', { field, value })
    return context.dispatch('fetchWarehouse')
  },

  refreshWarehouse({ dispatch }) {
    return dispatch('fetchWarehouse')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
